import Vue from 'vue/dist/vue'

export default function (baseRoute) {
    return {

        get (params, path) {
            if (path) { path = '/' + path; } else { path = '' }
            return Vue.http.get(Vue.baseUrl + '/' + baseRoute + path, { params: params });
        },
        getAll (params, path) {
            return this.get(params, path);
        },

        getOne (id, params) {
            return Vue.http.get(Vue.baseUrl + '/' + baseRoute + '/' + id, { params: params });
        },

        getCustom (path, params) {
            return this.get(params, path);
        },

        update (obj, path) {
            var tempPath = Vue.baseUrl + '/' + baseRoute;
            if (obj.id) {
                tempPath += '/' + obj.id;
            }
            if (path) {
                tempPath += '/' + path;
            }
            return Vue.http.put(tempPath, obj);
        },

        store (obj, path) {
            if (path) { path = '/' + path; } else { path = '' }
            return Vue.http.post(Vue.baseUrl + '/' + baseRoute + path, obj);
        },

        remove (id, params) {

            if (params) {
                return Vue.http.delete(Vue.baseUrl + '/' + baseRoute, { params: params });
            }
            return Vue.http.delete(Vue.baseUrl + '/' + baseRoute + '/' + id);
        },

        clone (id, params) {
            if (params) {
                return Vue.http.post(Vue.baseUrl + '/' + baseRoute, { params: params });
            }
            return Vue.http.post(Vue.baseUrl + '/' + baseRoute + '/' + id);
        },

        upload (path, data) {
            return Vue.http.post(Vue.baseUrl + '/' + baseRoute + '/' + path, data);
        }
    }
}
